// 3rd Party
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';

import { AnimatedContainer } from './styled-components';

// Component
const Animate = ({
  children,
  customStyles,
  delayIn = 0,
  delayOut = 0,
  duration = 0.4,
  maxHeight,
  show,
}) => {
  const [showChildren, setShowChildren] = useState(show);

  useEffect(() => {
    if (show) {
      setTimeout(() => setShowChildren(true), delayIn);
    } else {
      setTimeout(() => setShowChildren(false), delayOut);
    }
  }, [show]);

  return (
    <AnimatedContainer
      customStyles={customStyles}
      duration={duration}
      maxHeight={maxHeight}
      show={showChildren}
    >
      {showChildren && children}
    </AnimatedContainer>
  );
};

Animate.propTypes = {
  children: PropTypes.oneOfType([PropTypes.object, PropTypes.array]).isRequired,
  customStyles: PropTypes.array,
  delayIn: PropTypes.number,
  delayOut: PropTypes.number,
  duration: PropTypes.number,
  maxHeight: PropTypes.string,
  show: PropTypes.bool.isRequired,
};

export default Animate;
